import { Chart as ChartJS, TimeScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
import { Loader } from "../../components/loading/Loader";
import { ErgonomicsLeftPanel } from "./components/ErgonomicsLeftPanel";
import { ErgonomicsMainPanel } from "./components/ErgonomicsMainPanel";
import { ErgonomicsRightPanel } from "./components/ErgonomicsRightPanel";
import { ErgonomicsProvider, useErgonomicsContext } from "../../contexts/ErgonomicsContext";

ChartJS.register(TimeScale, LinearScale, BarElement, Tooltip, Legend, zoomPlugin, annotationPlugin);

export const ErgonomicsPage = () => {
  return (
    <ErgonomicsProvider>
      <ErgonomicsLayout/>
    </ErgonomicsProvider>
  );
};

const ErgonomicsLayout = () => {

  const { fields, isLoading } = useErgonomicsContext();

  if (fields.length === 0) return <Loader />;

  return (
      <div className="flex h-full">
        {
          isLoading && <Loader category="transparent"/>
        }
        <div className="w-1/6">
          <ErgonomicsLeftPanel/>
        </div>
        <div className="w-4/6">
          <ErgonomicsMainPanel/>
        </div>
        <div className="w-1/6">
          <ErgonomicsRightPanel/>
        </div>
      </div>
  );
};
